import { Modal } from './Modal';

export interface ConfirmDialogProps {
  isOpen: boolean;
  title: string;
  message: string;
  confirmLabel?: string;
  danger?: boolean;
  busy?: boolean;
  onConfirm: () => void;
  onCancel: () => void;
}

/**
 * Shared confirm-before-destructive-action dialog — used by every Delete action in this package
 * (Agent, Credential, Team, Team Member). All backend deletes here are soft deletes
 * (TeamService.SoftDeleteAsync, CredentialApiClient's doc-comment on deleteById, and Agent's
 * BaseAgentController delete route follows the same convention as every other entity in this
 * codebase) — the dialog says "delete", not "permanently delete", and offers no separate
 * restore/undo affordance in v1 (an explicit, documented simplification; restoring a soft-deleted
 * row isn't exposed anywhere in this UI yet).
 */
export function ConfirmDialog({ isOpen, title, message, confirmLabel = 'Delete', danger = true, busy, onConfirm, onCancel }: ConfirmDialogProps) {
  return (
    <Modal
      isOpen={isOpen}
      onClose={onCancel}
      title={title}
      width={420}
      footer={
        <>
          <button type="button" className="aaa-btn aaa-btn-default" onClick={onCancel} disabled={busy}>
            Cancel
          </button>
          <button
            type="button"
            className={`aaa-btn ${danger ? 'aaa-btn-danger' : 'aaa-btn-primary'}`}
            onClick={onConfirm}
            disabled={busy}
          >
            {busy ? 'Working…' : confirmLabel}
          </button>
        </>
      }
    >
      <p>{message}</p>
    </Modal>
  );
}
